/* eslint-disable no-underscore-dangle */
import getDaysInMonth from 'common/utils/generateDaysInMonth';
import dateFormater from 'common/utils/dateFormater';
import React from 'react';

const getAttendanceStatus = (attendances: any, day: any): JSX.Element => {
  let attendanceStatus = <b style={{ color: 'red' }}>A</b>;
  attendances.forEach((attendance: any) => {
    if (attendance.date.slice(8, 10) === day) {
      attendanceStatus = <b style={{ color: 'green' }}>P</b>;
    }
  });
  return attendanceStatus;
};

const tableColumn = (month: string, year: string): any => {
  return [
    {
      name: 'Name',
      selector: 'name',
      width: '100px',
      // sortable: true,
      cell: (row: any) => <b>{row.__user__.full_name}</b>,
    },
    ...Array.from({ length: getDaysInMonth(month, year) }, (_, i) => i + 1).map((item) => {
      const day = dateFormater(`${item}`);
      return {
        name: day,
        selector: day,
        width: '30px',
        //   sortable: true,
        cell: (row: any) => {
          return (
            <div>
              <div>{getAttendanceStatus(row.__attendances__, day)}</div>
            </div>
          );
        },
      };
    }),
  ];
};

export default tableColumn;
